import { default as constants } from "./../../constants.min.js";
import { default as utils } from "./../../utils.min.js";

function validateGetStartedForm($form) {
	let valid = true, // assume true. prove to be false
		$btnSubmit = $form.find(".btnSubmit"),
		$email = $form.find('[name="email'),
		validationErrors = [];

	// clear errors
	utils.clearFormErrors($form);

	// Validation
	if (!utils.validateFormField($email.val(), constants.REQUIRED) || !utils.validateEmailFormat($email.val())) {
		valid = false;
		utils.showFormFieldError($email, $email.data("validationmessage"));
		validationErrors.push('{"email", "' + $email.data("validationmessage") + '"}');
	}

	// Submit the form
	if (valid) {
		// Disabled and enable spinner
		utils.addSpinner($btnSubmit);

		$form.unbind("submit"); // Remove the preventDefault on submission
		$form.submit();
	} else {
		utils.removeSpinner($btnSubmit);
		utils.scrollToFirstError($form);
	}
}

$(document).ready(function () {
	$("form[name=getStarted]").on("submit", function (e) {
		e.preventDefault();
		validateGetStartedForm($(this));
	});
});
